import styled from 'styled-components';

export const SectionContainer = styled.div`
  flex-direction: column;
  display: flex;
  align-items: center;
  margin-top: 104px;
  padding: 28px;
  @media (max-width: 600px) {
    margin-top: 84px;
  }
`;

export const SectionHeading = styled.div`
  font-weight: 700;
  font-size: 36px;
  text-align: center;
  @media (max-width: 600px) {
    font-size: 28px;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  @media (max-width: 600px) {
    padding-top: 13px;
  }
`;

export const Icon = styled.img`
  margin: 24px;
  width: 72px;
  height: 72px;
	filter: grayscale();
  transition: filter 0.3s ease-in-out;
  &:hover  {
    filter: none; }
  @media (max-width: 600px) {
    margin: 21px;
    width: 40px;
    height: 40px;
    filter: none;
  }
`;
